import React from 'react'
import PropTypes from 'prop-types';
import { CandidatesPropType } from './index';
import { ButtonMore, Candidates, Line, Subtitle } from './styles';
import More from '../Button/More';
import Title from '../../Symbols/Title';

export default class DistrictPreview extends React.PureComponent {
	state = {
		showCandidates: false
	}

	onClick = () => this.setState(state => ({ showCandidates: !state.showCandidates }));

	render() {
		return (
			<Line>
				<Subtitle>
					{this.props.districtNumber} - {this.props.name}
				</Subtitle>
				<ButtonMore>
					<More
						whenClosed={'Kandidáti'}
						whenOpened={'Méně kandidátů'}
						opened={this.state.showCandidates}
						onClick={this.onClick}
					/>
				</ButtonMore>
				{this.state.showCandidates && (
					<Candidates>
						<thead>
							<tr>
								<td colSpan="2">
									<Title>
										Seznam kandidátů
									</Title>
								</td>
							</tr>
						</thead>
						<tbody>
							{this.props.candidates.map(candidate => (
								<tr key={candidate.id}>
									<td>{candidate.name} {candidate.lastName}</td>
									<td>{candidate.partyName}</td>
								</tr>
							))}
						</tbody>
					</Candidates>
				)}
			</Line>
		)
	}

}

DistrictPreview.propTypes = {
	name: PropTypes.string,
	districtNumber: PropTypes.number,
	candidates: CandidatesPropType
}
